module.exports = "https://assets.sidelineswap.com/web/_next/static/videos/13-d5afe28b59be89aa81aff84dbde2247f.webm";